import { useDispatch, useSelector } from "react-redux";
import {
  selectAIQuestions,
  selectIsEditingQuestion,
  selectIsCreatingAddingKnowledge,
  selectIsGenerateSolution,
} from "../../redux/questions/selectors";
import {
  aiCreateQuestionStart,
  resetAIQuestions,
  saveGeneratedQuestionStart,
  createAddKnowledgeStart
} from "../../redux/questions/reducer";

const useAIQuestionCreate = () => {
  const dispatch = useDispatch();
  const generatedQuestions = useSelector(selectAIQuestions);
  const isAddingKnowledge = useSelector(selectIsCreatingAddingKnowledge);
  const isGenerating = useSelector(selectIsGenerateSolution);
  const isSaving = useSelector(selectIsEditingQuestion);

  const generateAIQuestions = (data) => {
    dispatch(aiCreateQuestionStart(data));
  };

  const resetAIQuestionReducer = () => {
    dispatch(resetAIQuestions());
  };

  const saveAIQuestions = (data) => {
    dispatch(saveGeneratedQuestionStart(data));
  };

   const saveAddingKnowledge = (data) =>{
    dispatch(createAddKnowledgeStart(data))
   }
  return {
    generatedQuestions,
    isGenerating,
    isSaving,
    resetAIQuestionReducer,
    generateAIQuestions,
    saveAIQuestions,
    saveAddingKnowledge,
    isAddingKnowledge
  };
};

export default useAIQuestionCreate;
